import {
  Button,
  Card,
  CircularProgress,
  Modal,
  TextField,
  Typography,
  Avatar,
  Badge,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import SnackBarUI from "../../common/SnackUI";
import { monthWiseEarningAction } from "../../redux/toolkit/payments/month-wise-earning";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import PaymentRequest from "./PaymentRequest";
import { monthWiseChargebackAction } from "../../redux/toolkit/payments/month-wise-chargeback";

const MonthWiseEarning = ({ state, setState }) => {
  const [snack, setSnack] = useState(false);
  const dispatch = useDispatch();
  const monthWiseEarningData = useSelector((state) => state.monthWiseEarning);
  const monthWiseChargebackData = useSelector(
    (state) => state.monthWiseChargeback
  );
  const { status, message, data, loading } = monthWiseEarningData;
  const { data: chargeBackData, loading: chargeBackLoading } =
    monthWiseChargebackData;

  const [createPay, setCreatePay] = useState(false);
  const [dateData, setDateData] = useState({});

  const monthsName = {
    1: "January",
    2: "February",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December",
  };

  const handleClose = () => {
    setState(false);
  };

  // useEffect(() => {
  //   dispatch(monthWiseEarningAction());
  //   dispatch(monthWiseChargebackAction());
  // }, [dispatch]);




  return (
    <>
      {/* <Modal
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background:'rgba(0,0,0,0.5)',
                    zIndex:99999,
                    backdropFilter:"blur(5px)"
                }}
                sx={{ overflow: "scroll" }}
                open={state}
                onClose={handleClose}
            >
                <Box className="modal_box" sx={{display:"flex",alignItems:"center",justifyContent:"center"}} >
                    <Card sx={{ width: 1000, p: 5, }}>
                        <Typography variant="h5" sx={{ mb: 5 }} align="center">
                            Month Wise Earning Data
                        </Typography>
                        <Stack spacing={3}>

                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="left">Month</TableCell>
                                            <TableCell align="right">Year</TableCell>

                                            <TableCell align="right">Earning&nbsp;($)</TableCell>
                                            <TableCell align="right">Chargeback&nbsp;($)</TableCell>
                                            <TableCell align="right">Raise Request&nbsp;</TableCell>

                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data.map((row) => (
                                            <TableRow
                                                key={row._id?.month}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell component="th" scope="row">
                                                    {monthsName[row._id?.month]}
                                                </TableCell>
                                                <TableCell align="right">{row?._id?.year}</TableCell>
                                                <TableCell align="right">{Number(row.totalEarningsWithBonus).toFixed(4)}</TableCell>
                                                <TableCell align="right">{Math.abs(Number(row.chargeBackAmount)).toFixed(4)}</TableCell>
                                                <TableCell align="right"><Button variant="contained" onClick={() =>{ setCreatePay(true) ;setDateData(row)}}>Raise Request</Button></TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Stack>
                    </Card>
                </Box>
            </Modal> */}

      <Modal
        open={state}
        onClose={handleClose}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "rgba(0,0,0,0.5)",
          zIndex: 99999,
          backdropFilter: "blur(5px)",
          overflow: "auto", // scrollable for mobile
        }}
      >
        <Box
          className="modal_box"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            px: 2,
            py: 4,
          }}
        >
          <Card
            sx={{
              width: { xs: "100%", sm: "90%", md: "80%", lg: "60%" },
              maxWidth: "1000px",
              p: { xs: 2, sm: 5 },
              mx: "auto",
              overflowX: "auto",
            }}
          >
            <Typography variant="h5" sx={{ mb: 5 }} align="center">
              Month Wise Earning Data
            </Typography>

            <Stack spacing={3}>
              <TableContainer component={Paper} sx={{ overflowX: "auto" }}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">Month</TableCell>
                      <TableCell align="right">Year</TableCell>
                      <TableCell align="right">Earning&nbsp;($)</TableCell>
                      <TableCell align="right">Chargeback&nbsp;($)</TableCell>
                      <TableCell align="right">Raise Request</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {data?.length > 0
                      && data.map((val) => {
                      let chargeback = chargeBackData?.find(
                            (item) =>
                              item?._id?.month === val?._id?.month &&
                              item?._id?.year === val?._id?.year
                          );
                          return { ...val,chargeBackAmount:chargeback?.totalEarningChargeback || 0}
                         
                        }).map((row) => (
                          <TableRow
                            key={row._id?.month}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell component="th" scope="row">
                              {monthsName[row._id?.month]}
                            </TableCell>
                            <TableCell align="right">
                              {row?._id?.year}
                            </TableCell>
                            <TableCell align="right">
                              {Number(row.totalEarningsWithBonus).toFixed(4)}
                            </TableCell>
                            <TableCell align="right">
                              {Math.abs(Number(row.chargeBackAmount)).toFixed(
                                4
                              )}
                            </TableCell>
                            <TableCell align="right">
                              <Button
                                variant="contained"
                                onClick={() => {
                                  setCreatePay(true);
                                  setDateData(row);
                                }}
                              >
                                Raise Request
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Stack>
          </Card>
        </Box>
      </Modal>

      {
        <PaymentRequest
          state={createPay}
          setState={setCreatePay}
          dateData={dateData}
        />
      }

      <SnackBarUI
        state={snack}
        setState={setSnack}
        status={status}
        message={message}
      />
    </>
  );
};

export default MonthWiseEarning;
